import PersonalizationCardImage from "./components/PersonalizationCardImage";
import PersonalizationInput from "./components/PersonalizationInput";
import PersonalizationTextarea from "./components/PersonalizationTextarea";
import PersonalizationDivider from "./components/PersonalizationDivider";

export default function PersonalizationNextTopHealthConcernsIntro({getError,healthConcernsFormData,setHealthConcernsFormData}) {
    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap:'20px'
    }}>
        <PersonalizationCardImage src={'/assets/survey_personalization_screens/top_3_1.png'} alt={'Welcome Screen'} />

        <PersonalizationInput
            title={'Section Title'}
            value={healthConcernsFormData?.nextTitle}
            setValue={(value) => setHealthConcernsFormData({nextTitle:value})}
            errorMessage={getError('healthConcerns','nextTitle')}
        />

        <PersonalizationTextarea
            title={'Description'}
            value={healthConcernsFormData?.nextDesc}
            setValue={(value) => setHealthConcernsFormData({nextDesc:value})}
            errorMessage={getError('healthConcerns','nextDesc')}
        />

        <PersonalizationInput
            title={'Video Link (Optional)'}
            value={healthConcernsFormData?.nextVideoUrl}
            setValue={(value) => setHealthConcernsFormData({nextVideoUrl:value})}
            errorMessage={getError('healthConcerns','nextVideoUrl')}
        />

    </div>
}
